import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer } from '@mui/material';
import { List } from '@mui/material';
import { MainListItems, SecondaryListItems } from '../HeaderMenu';
import { Box } from '@mui/system';
import '../../App.css';
import styles from './UserDrawer.module.css';
import { Hub } from 'aws-amplify';
import usersService from '../../axios/usersService';
import { FiltersContext } from '../../components/Navigation/Routes';
import featureToggle from '../../featureToggle.json';

const secondaryNavItems = [
  {name: "training", title: "TRAINING", path: "/training"},
  {name: "faq", title: "FAQs", path: "/faqs"}
];

export function UserDrawer(props) {
  const [navItems, setNavItems] = useState([]);
  const context = useContext(FiltersContext);
  const navigate = useNavigate();
  const { setSubId, impersonatorInfo } = context;

  useEffect(() => {
    Hub.listen('refresh', async () => {
      const subIdRes = await usersService.getSubId();
      setSubId(subIdRes);
      let navRes = await usersService.getNav();
      if (!featureToggle[process.env.REACT_APP_ENVIRONMENT]['customer-data']) {
        let objectToChange = navRes.find((obj) => obj.name === 'dataQuery');
        objectToChange.children = objectToChange.children.slice(0, 3);
      }
      if (!featureToggle[process.env.REACT_APP_ENVIRONMENT]['contact-directory']) {
        navRes = navRes.filter((obj) => obj.name !== 'contactDirectory');
      }
      setNavItems(navRes);
    });
  }, [setSubId]);

  useEffect(() => {
    const fetchNavRoutes = async () => {
      let navRes = await usersService.getNav(impersonatorInfo);
      if (!featureToggle[process.env.REACT_APP_ENVIRONMENT]['customer-data']) {
        let objectToChange = navRes.find((obj) => obj.name === 'dataQuery');
        objectToChange.children = objectToChange.children.slice(0, 3);
      }
      if (!featureToggle[process.env.REACT_APP_ENVIRONMENT]['contact-directory']) {
        navRes = navRes.filter((obj) => obj.name !== 'contactDirectory');
      }
      setNavItems(navRes);
    };
    fetchNavRoutes();
    navigate('/');
    // impersonatorInfo is intentionally tracked via impersonatorInfo.name
    // rather than by reference, to avoid re-running on unrelated updates.
    // navigate is intentionally omitted: react-router's useNavigate() returns
    // a new function identity on every route change, so including it here
    // would re-fire this effect (and navigate('/')) on every nav click.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [impersonatorInfo.name]);

  const mainNavItems = navItems?.filter((navItem) => navItem.name !== "admin" && navItem.name !== "supplierAdmin");
  const adminNav = navItems?.find((navItem) => navItem.name === "admin");
  const supplierAdminNav = navItems?.find((navItem) => navItem.name === "supplierAdmin");

  let secondaryNavItemsFinal = secondaryNavItems;
  if (supplierAdminNav) {
    secondaryNavItemsFinal = secondaryNavItemsFinal.concat(supplierAdminNav);
  }
  if (adminNav) {
    secondaryNavItemsFinal = secondaryNavItemsFinal.concat(adminNav);
  }

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === 'bottom' ? 'auto' : 220,
        height: anchor === 'left' ? '100%' : null,
      }}
      role="presentation"
      onClick={props.drawerClose}
      onKeyDown={props.drawerClose}
    >
      <List className={`leftside-list ${styles['leftside-list']}`}>
        {anchor === 'left' ? <MainListItems navItems={mainNavItems}/> : <SecondaryListItems navItems={secondaryNavItemsFinal}/>}
      </List>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      position="fixed"
      variant="permanent"
      sx={{
        width: 220,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 220,
          paddingTop: '10px',
          height: '100%',
          overflowX: 'hidden',
          overflowY: 'hidden',
          backgroundColor: '#FFFFFF',
          boxSizing: 'border-box',
          borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        },
      }}
      className={styles['drawer-border']}
    >
      <div className="logo-container">
        <img
          alt="shortened-logo"
          className="app-bar-logo"
          src="/USF-ST-logo.png"
        />
      </div>
      {list('left')}
      {list('bottom')}
    </Drawer>
  );
}
